import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import Calendar from './Calendar';
import DomModal from '../Modal/DomModal';

loadDOMComponent({
	selector: 'react-calendar-modal',
	callback: ({ container }) => {
		let openedCallbackX = undefined;
		const opened = false;

		const openedCallback = x => {
			openedCallbackX = x;
		};

		container.addEventListener('toggle', () => {
			if (openedCallbackX) {
				openedCallbackX(!opened);
			}
		});

		ReactDOM.render(
			<AppContextProvider>
				<DomModal openedCallback={openedCallback}>
					<Calendar />
				</DomModal>
			</AppContextProvider>,
			container,
		);
	},
});
